import { colors, font } from "../styles/theme";
import { contacts } from "../data/company";

// Крупный логотип + «ВК-КЛИМАТ» в hero, исчезает при скролле (когда появляется шапка).
export default function HeroBrand({ dark = false, hidden = false, logo = 84, size = "clamp(34px,5vw,48px)", tagline = true }) {
  return (
    <div
      style={{
        transition: "opacity .5s ease, transform .5s ease",
        opacity: hidden ? 0 : 1,
        transform: `translateY(${hidden ? "-16px" : "0"})`,
        pointerEvents: hidden ? "none" : "auto",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 0, flexWrap: "wrap" }}>
        <img src="/logo-klimat.png" alt="ВК-КЛИМАТ" style={{ width: logo, height: logo, objectFit: "contain" }} />
        <div>
          <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: size, lineHeight: 1 }}>
            <span style={{ color: dark ? "#fff" : colors.ink }}>ВК</span>
            <span style={{ color: colors.red }}>-КЛИМАТ</span>
          </div>
          {tagline && (
            <div
              style={{
                fontFamily: font.body,
                fontSize: 11,
                letterSpacing: ".08em",
                textTransform: "uppercase",
                color: dark ? "#9aa1ab" : "#7a828c",
                marginTop: 6,
              }}
            >
              {contacts.tagline}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
